var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Guest'),(_vm.$auth.check())?_c('v-container',[_c('Greeting'),(_vm.driver)?_c('Panels'):_vm._e(),(!_vm.loading && !_vm.driver)?_c('NewDriver'):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }